const { EventEmitter } = require('events')

const eventService = new EventEmitter()

export { eventService }
